export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue) {
    Vue.prototype.forceFileDownload = (response, filename) => {
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      console.log(url)
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/forceFileDownload.js